import React, { useState } from 'react'

import {
  StyleSheet,
  View,
  Text,
  Dimensions
} from 'react-native'

import {
  adaptive
} from '@sart/styles'

import { useContent } from '@sart/content'

export default function MoveHome(props) {
  // const { navigation } = props
  const content = useContent()

  return (
    <View style={styles.container}>
        <Text>{content.general.comingSoon}</Text>
    </View>
  )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginTop: 25,
        ...adaptive.wrapperPadding
    }
})
